import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import Feed from "./components/Feed";
import Feature from "./components/Feature";
import Reviews from "./components/Reviews";
import Faq from "./components/Faq";
import AboutContact from "./components/AboutContact";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <Feed />
        <Feature />
        <Reviews />
        <Faq />
        <AboutContact />
      </main>
      <Footer />

      <a
        href="#top"
        aria-label="返回顶部"
        className={`fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-card transition-all hover:bg-primary-600 md:bottom-8 md:right-8 ${
          showTop ? "opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-xl"></i>
      </a>
    </>
  );
}